import { SALES_ANALYSIS_DASHBOARD_API } from "@/constants/salesAnalysisDashboardApi.js";
import router from "@/router";
import store from "@/store";
import axios from "axios";
import { ref } from "vue";

export const commonUrl = "http://localhost:50447";
export const commonUrl2 = "https://pncapi.kr"; // REST API — 로고·이미지는 별도 서버(pncapi.kr:88), @/constants/pncHosts
// Axios 인스턴스 생성 (기본 설정)
const api = axios.create({
  baseURL: commonUrl, // API 기본 URL
  timeout: 30000, // 요청 타임아웃 설정
});
const api2 = axios.create({
  baseURL: commonUrl2, // API 기본 URL
  timeout: 30000, // 요청 타임아웃 설정
});

api2.interceptors.request.use(
  (config) => {
    const token = store.state.StoreToken;
    //comsole.log(token);
    config.headers["Authorization"] = `Bearer ${token}`;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api2.interceptors.response.use(
  (response) => {
    if (response.headers.authorization) {
      let newtoken = response.headers.authorization.substring(7);

      store.state.StoreToken = newtoken;
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status == 401) {
      //alert("로그인 시간이 1분 이상 지났습니다. 재로그인 해주세요.");
      store.commit("clearSession");
      router.push("/");
    }
    /* 영원히 pending 인 Promise 를 반환하면 호출부(await / allSettled)가 끝나지 않아 로딩이 풀리지 않음 */
    return Promise.reject(error);
  }
);
// API 요청 메서드들
export const login = async (username, password) => {
  return api2.post("/SYSTEM/system.asmx/getLoginSession", {
    USER_ID: username,
    PASSWORD: password,
  });
};

export const get_sys_list = (lngStoreGroup, lngUserAdminID, strLanguage) => {
  return api2.post("/SYSTEM/system.asmx/getSysMenuList", {
    GROUP_CD: lngStoreGroup,
    USER_ADMIN_ID: lngUserAdminID,
    STR_LANGUAGE: strLanguage,
  });
};
export const get_store_list = (
  lngStoreGroup,
  lngpositiontype,
  blnbrandadmin,
  lngposition,
  lngjointype,
  lngTeamCode,
  lngSupervisor
) => {
  return api2.post("/SYSTEM/sysCom.asmx/getComStoreList", {
    STORE_CD: lngStoreGroup,
    LNG_POSITION_TYPE: lngpositiontype,
    BLN_BRAND_ADMIN: blnbrandadmin,
    LNG_POSITION: lngposition,
    LNG_JOINTYPE: lngjointype,
    LNG_TEAMCODE: lngTeamCode,
    LNG_SUPERVISOR: lngSupervisor,
  });
};
/** pickStore.vue 가운데 콤보. mstStoreAttr. getComStoreList 의 storeAttr(직영/가맹)과 분리. */
export const getComStoreAttrList = (
  lngStoreGroup,
  lngpositiontype,
  blnbrandadmin,
  lngposition
) => {
  return api2.post("/SYSTEM/sysCom.asmx/getComStoreAttrList", {
    lngStoreGroup: lngStoreGroup,
    LNG_POSITION_TYPE: lngpositiontype,
    BLN_BRAND_ADMIN: blnbrandadmin,
    lngStoreCode: lngposition,
  });
};
export const getStoreList = (lngStoreGroup, lngStoreCode) => {
  return api2.post("/SYSTEM/sysCom.asmx/getStoreList2", {
    GROUP_CD: lngStoreGroup,
    STORE_CD: lngStoreCode,
  });
};
export const getStoreList2 = (lngStoreGroup) => {
  return api2.post("/SYSTEM/sysCom.asmx/getStoreList", {
    GROUP_CD: lngStoreGroup,
  });
};

export const getGridInfoList = async (P_ID, G_ID) => {
  const tabInitSetArray = ref([]);
  const res = await api2.post("/SYSTEM/system.asmx/getGridInfoList", {
    PROG_ID: P_ID,
    GRID_ID: G_ID,
  });

  tabInitSetArray.value = res.data.gridInfo;

  return tabInitSetArray.value;
};
export const getRenderingData = async (P_ID) => {
  const tabInitSetArray = ref([]);
  const res = await api2.post("/SYSTEM/system.asmx/getRenderData", {
    PROG_ID: P_ID,
  });

  tabInitSetArray.value = res.data.renderInfo;

  return tabInitSetArray.value;
};

export const getPosList = async (groupCd, storeCd) => {
  const res = await api2.post("/SYSTEM/sysCom.asmx/getPosList", {
    GROUP_CD: groupCd,
    STORE_CD: storeCd,
  });
  return res;
};
export const getPosList2 = async (groupCd, storeCd) => {
  const res = await api2.post("/SYSTEM/sysCom.asmx/getPosList2", {
    GROUP_CD: groupCd,
    STORE_CD: storeCd,
  });
  return res;
};

export const getPosList3 = async (groupCd, storeCd) => {
  const res = await api2.post("/SYSTEM/sysCom.asmx/getPosList3", {
    GROUP_CD: groupCd,
    STORE_CD: storeCd,
  });
  return res;
};
export const getKioskList = async (groupCd, storeCd) => {
  const res = await api2.post("/SYSTEM/sysCom.asmx/getKioskList", {
    GROUP_CD: groupCd,
    STORE_CD: storeCd,
  });
  return res;
};
export const getTablePosList = async (groupCd, storeCd) => {
  const res = await api2.post("/SYSTEM/sysCom.asmx/getTablePosList", {
    GROUP_CD: groupCd,
    STORE_CD: storeCd,
  });
  return res;
};
export const getStoreAndPosList = async (
  groupCd,
  storeCd,
  posNo,
  blnBrandAdmin
) => {
  const res = await api2.post("/SYSTEM/sysCom.asmx/getStoreAndPosList", {
    GROUP_CD: groupCd,
    STORE_CD: storeCd,
    POSNO: posNo,
    BLN_BRAND_ADMIN: blnBrandAdmin,
  });
  return res;
};
export const getStoreAndPosList2 = async (
  groupCd,
  storeCd,
  posNo,
  blnBrandAdmin
) => {
  const res = await api2.post("/SYSTEM/sysCom.asmx/getStoreAndPosList2", {
    GROUP_CD: groupCd,
    STORE_CD: storeCd,
    POSNO: posNo,
    BLN_BRAND_ADMIN: blnBrandAdmin,
  });
  return res;
};
export const getStoreAndPosList4 = async (
  groupCd,
  storeCd,
  posNo,
  blnBrandAdmin
) => {
  const res = await api2.post("/SYSTEM/sysCom.asmx/getStoreAndPosList4", {
    GROUP_CD: groupCd,
    STORE_CD: storeCd,
    POSNO: posNo,
    BLN_BRAND_ADMIN: blnBrandAdmin,
  });
  return res;
};
export const getStoreDistinctList = async (groupCd, storeCd, areaCd, posNo) => {
  const res = await api2.post("/SYSTEM/sysCom.asmx/getStoreDistinctList", {
    GROUP_CD: groupCd,
  });
  return res;
};

export const getStoreAndPosList3 = async (
  groupCd,
  storeCd,
  areaCd,
  posNo,
  blnBrandAdmin
) => {
  const res = await api2.post("/SYSTEM/sysCom.asmx/getStoreAndPosList3", {
    GROUP_CD: groupCd,
    STORE_CD: storeCd,
    AREA_CD: areaCd,
    POSNO: posNo,
    BLN_BRAND_ADMIN: blnBrandAdmin,
  });
  return res;
};
export const savePageLog = async (
  time,
  group,
  store,
  userid,
  userip,
  progname,
  progid,
  bln
) => {
  const res = await api2.post("/SYSTEM/sysCom.asmx/savePageLog", {
    TIME: time,
    GROUP: group,
    STORE: store,
    USERID: userid,
    USERIP: userip,
    PROGNAME: progname,
    PROGID: progid,
    BLN: bln,
  });
  return res;
};

export const saveLoginLog = async (
  time,
  group,
  store,
  id,
  pw,
  ip,
  type,
  bln
) => {
  const res = await api2.post("/SYSTEM/sysCom.asmx/saveLoginLog", {
    TIME: time,
    GROUP: group,
    STORE: store,
    USERID: id,
    USERPW: pw,
    USERIP: ip,
    TYPE: type,
    BLN: bln,
  });
  return res;
};
export const alreadyLogined = (token) => {
  return api2.post("/SYSTEM/VERIFYLOGIN.asmx/alreadyLogined", {
    TOKEN: token,
  });
};
export const alreadyMobileLogined = (token) => {
  return api2.post("/SYSTEM/VERIFYLOGIN.asmx/alreadyMobileLogined", {
    TOKEN: token,
  });
};

export const getFavoriteList = (userid) => {
  return api2.post("/SYSTEM/system.asmx/getFavoriteList", {
    USER_ID: userid,
  });
};
export const addFavorite = (progid, userid) => {
  return api2.post("/SYSTEM/system.asmx/addFavorite", {
    PROG_ID: progid,
    USER_ID: userid,
  });
};
export const deleteFavorite = (progid, userid) => {
  return api2.post("/SYSTEM/system.asmx/deleteFavorite", {
    PROG_ID: progid,
    USER_ID: userid,
  });
};

export const createItem = (item) => api.post("/items", item);
export const updateItem = (id, item) => api.put(`/items/${id}`, item);
export const deleteItem = (id) => api.delete(`/items/${id}`);

export const getCommonList = (code) => {
  return api2.post("/SYSTEM/sysCom.asmx/getCommonCode", {
    CODE: code,
  });
};

export const MainDashBoard = (groupcd, storecd, sublease, sequence, lang) => {
  return api2.post("/SYSTEM/sysCom.asmx/getYesterdayClose", {
    GROUP_CD: groupcd,
    STORE_CD: storecd,
    SUBLEASE: sublease,
    SEQUENCE: sequence,
    LANGUAGE: lang,
  });
};
export const MainDashBoard2 = (groupcd, storecd, sequence) => {
  return api2.post("/SYSTEM/sysCom.asmx/MainDashBoard2", {
    GROUP_CD: groupcd,
    STORE_CD: storecd,
    SEQUENCE: sequence,
  });
};
export const MainDashBoard3 = (groupcd, storecd) => {
  return api2.post("/SYSTEM/sysCom.asmx/MainDashBoard3", {
    GROUP_CD: groupcd,
    STORE_CD: storecd,
  });
};

/**
 * `SLS00_001DASH.asmx` 5개 웹메서드 공통 요청 바디.
 * @param {string|number} groupCd GROUP_CD
 * @param {string|number} storeCd STORE_CD (본사 0 — 프론트 `SalesAnalysisDashboard` 의 본사 판별과 동일하게 전달)
 * @param {string|number} sequence SEQUENCE
 * @param {string} fromDt FROM_DT (`yyyy-mm-dd`, Asia/Seoul 당월 1일 등)
 * @param {string} toDt TO_DT (`yyyy-mm-dd`)
 * @returns {{ GROUP_CD: string|number; STORE_CD: string|number; SEQUENCE: string|number; FROM_DT: string; TO_DT: string }}
 */
export const buildSalesAnalysisDashBody = (
  groupCd,
  storeCd,
  sequence,
  fromDt,
  toDt
) => ({
  GROUP_CD: groupCd,
  STORE_CD: storeCd,
  SEQUENCE: sequence,
  FROM_DT: fromDt,
  TO_DT: toDt,
});

/**
 * 홈 매출 분석 — 주간 핵심 지표
 * @see buildSalesAnalysisDashBody
 */
export const getWeeklyKeyIndicators = (
  groupCd,
  storeCd,
  sequence,
  fromDt,
  toDt
) => {
  return api2.post(
    SALES_ANALYSIS_DASHBOARD_API.weeklyKeyIndicators,
    buildSalesAnalysisDashBody(groupCd, storeCd, sequence, fromDt, toDt)
  );
};

/**
 * 홈 매출 분석 — 객수/객단가 매장별
 * @see buildSalesAnalysisDashBody
 */
export const getCustomerAndUnitPriceByStore = (
  groupCd,
  storeCd,
  sequence,
  fromDt,
  toDt
) => {
  return api2.post(
    SALES_ANALYSIS_DASHBOARD_API.customerAndUnitPriceByStore,
    buildSalesAnalysisDashBody(groupCd, storeCd, sequence, fromDt, toDt)
  );
};

/**
 * 홈 매출 분석 — 매장 매출 매장별
 * @see buildSalesAnalysisDashBody
 */
export const getStoreSalesByStore = (
  groupCd,
  storeCd,
  sequence,
  fromDt,
  toDt
) => {
  return api2.post(
    SALES_ANALYSIS_DASHBOARD_API.storeSalesByStore,
    buildSalesAnalysisDashBody(groupCd, storeCd, sequence, fromDt, toDt)
  );
};

/**
 * 홈 매출 분석 — 재료비 매장별
 * @see buildSalesAnalysisDashBody
 */
export const getMaterialCostByStore = (
  groupCd,
  storeCd,
  sequence,
  fromDt,
  toDt
) => {
  return api2.post(
    SALES_ANALYSIS_DASHBOARD_API.materialCostByStore,
    buildSalesAnalysisDashBody(groupCd, storeCd, sequence, fromDt, toDt)
  );
};

/**
 * 홈 매출 분석 — 예약현황 매장별 (`usp_VUE_saGetReservationByStore`)
 * @see buildSalesAnalysisDashBody
 */
export const getReservationByStore = (
  groupCd,
  storeCd,
  sequence,
  fromDt,
  toDt
) => {
  return api2.post(
    SALES_ANALYSIS_DASHBOARD_API.reservationByStore,
    buildSalesAnalysisDashBody(groupCd, storeCd, sequence, fromDt, toDt)
  );
};

/** @deprecated getReservationByStore 사용 */
export const getReservationStatusByStore = getReservationByStore;

/**
 * @deprecated 예약현황으로 교체 — getReservationByStore 사용
 * @see buildSalesAnalysisDashBody
 */
export const getLaborCostByStore = (
  groupCd,
  storeCd,
  sequence,
  fromDt,
  toDt
) => {
  return api2.post(
    SALES_ANALYSIS_DASHBOARD_API.laborCostByStore,
    buildSalesAnalysisDashBody(groupCd, storeCd, sequence, fromDt, toDt)
  );
};
